
(function () {
  function pret(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  pret(function () {
    var racine = document.querySelector('.nap');
    if (!racine) return;
    /* ---- galerie (leur slider Dawn : defilement natif + fleches + compteur + vignettes) ---- */
    var liste = racine.querySelector('.product__media-list');
    var slides = liste ? Array.prototype.slice.call(liste.querySelectorAll('.product__media-item')) : [];
    var courant = racine.querySelector('.slider-counter--current');
    var pouces = Array.prototype.slice.call(racine.querySelectorAll('.thumbnail-list__item'));
    function actif() {
      if (!liste) return 0;
      var x = liste.scrollLeft, best = 0, d = 1e9;
      slides.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - liste.offsetLeft - x); if (dd < d) { d = dd; best = i; } });
      return best;
    }
    function maj() {
      var i = actif();
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      if (courant) courant.textContent = i + 1;
      pouces.forEach(function (p, k) { var b = p.querySelector('button'); if (b) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); } });
    }
    function aller(i) { if (!liste || !slides[i]) return; liste.scrollTo({ left: slides[i].offsetLeft - liste.offsetLeft, behavior: 'smooth' }); }
    if (liste) {
      liste.addEventListener('scroll', function () { window.requestAnimationFrame(maj); }, { passive: true });
      Array.prototype.slice.call(racine.querySelectorAll('.product-media-slider .slider-button--prev')).forEach(function (b) { b.addEventListener('click', function () { aller(actif() - 1); }); });
      Array.prototype.slice.call(racine.querySelectorAll('.product-media-slider .slider-button--next')).forEach(function (b) { b.addEventListener('click', function () { aller(actif() + 1); }); });
      pouces.forEach(function (p, k) { p.addEventListener('click', function () { aller(k); }); });
      var tl = racine.querySelector('.thumbnail-slider');
      if (tl) {
        var tp = tl.querySelector('.slider-button--prev'), tn = tl.querySelector('.slider-button--next'), tu = tl.querySelector('.thumbnail-list');
        if (tp && tu) tp.addEventListener('click', function () { tu.scrollBy({ left: -tu.clientWidth, behavior: 'smooth' }); });
        if (tn && tu) tn.addEventListener('click', function () { tu.scrollBy({ left: tu.clientWidth, behavior: 'smooth' }); });
      }
      maj();
    }
    /* ---- guide des tailles : leur photo 8 ---- */
    var guia = document.createElement('div');
    guia.className = 'nap-guia';
    var g8 = racine.querySelector('[data-nap-guia-img] img'), src8 = g8 ? g8.getAttribute('src') : '';
    guia.innerHTML = '<button type="button" aria-label="Cerrar">&times;</button><img alt="Guía de tallas" src="' + src8 + '">';
    document.body.appendChild(guia);
    guia.addEventListener('click', function (e) { if (e.target === guia || e.target.tagName === 'BUTTON') guia.classList.remove('is-open'); });
    Array.prototype.slice.call(racine.querySelectorAll('[data-nap-guia]')).forEach(function (o) {
      o.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); guia.classList.add('is-open'); }, true);
    });
    /* ---- Moon Bundle masque les selecteurs de variantes (hideThemePicker) : on annule dans notre bloc ---- */
    function demasquer() {
      Array.prototype.forEach.call(racine.querySelectorAll('.kaching-bundles [style*="display: none"], .kaching-bundles [style*="visibility: hidden"]'), function (el) {
        el.style.removeProperty('display'); el.style.removeProperty('visibility');
      });
    }
    demasquer();
    var kb = racine.querySelector('.kaching-bundles');
    if (kb && window.MutationObserver) new MutationObserver(demasquer).observe(kb, { attributes: true, subtree: true, attributeFilter: ['style'] });
    /* ---- offre : leur bloc Kaching, nos variantes ---- */
    var V = window.NAP_VARIANTES || {};
    var bars = Array.prototype.slice.call(racine.querySelectorAll('[data-nap-oferta]'));
    var form = document.getElementById('nap-form');
    var NOMS = { '1': '1 Tank + 1 Gratis', '2': '2 Tank + 1 Gratis', '3': '3 Tank + 2 Gratis' };
    function choisir(bar) {
      bars.forEach(function (b) { b.classList.toggle('kaching-bundles__bar--selected', b === bar); });
      sync();
    }
    function variante(u) {
      var c = u.querySelector('[data-nap-color]').value, t = u.querySelector('[data-nap-talla]').value;
      return V[c + ' / ' + t];
    }
    function sync() {
      if (!form) return;
      var bar = racine.querySelector('[data-nap-oferta].kaching-bundles__bar--selected') || bars[0];
      var unites = bar.querySelectorAll('[data-nap-unidad]');
      var idInput = form.querySelector('[data-nap-id]'), items = form.querySelector('[data-nap-items]');
      items.innerHTML = '';
      if (unites.length === 1) {
        idInput.disabled = false;
        idInput.value = variante(unites[0]) || idInput.value;
        return;
      }
      /* plusieurs pieces : une ligne par couleur + talla, quantites regroupees ; la remise automatique fait le prix */
      idInput.disabled = true;
      var q = {}, ordre = [];
      Array.prototype.forEach.call(unites, function (u) { var id = variante(u); if (!id) return; if (!q[id]) { q[id] = 0; ordre.push(id); } q[id]++; });
      ordre.forEach(function (id, k) {
        items.insertAdjacentHTML('beforeend',
          '<input type="hidden" name="items[' + k + '][id]" value="' + id + '">' +
          '<input type="hidden" name="items[' + k + '][quantity]" value="' + q[id] + '">');
      });
    }
    bars.forEach(function (b) {
      b.addEventListener('click', function (e) { if (e.target.closest('select')) return; if (!b.classList.contains('kaching-bundles__bar--selected')) choisir(b); });
      Array.prototype.slice.call(b.querySelectorAll('select')).forEach(function (s) {
        s.addEventListener('click', function (e) { e.stopPropagation(); if (!b.classList.contains('kaching-bundles__bar--selected')) choisir(b); });
        s.addEventListener('change', function () {
          if (s.hasAttribute('data-nap-color')) {
            var dd = s.closest('.kaching-bundles__swatch-dropdown'), o = s.options[s.selectedIndex], img = o.getAttribute('data-img');
            dd.setAttribute('data-value', s.value);
            var sw = dd.querySelector('.kaching-bundles__swatch');
            if (sw) sw.style.setProperty('--kaching-swatch-image-url', 'url(' + img + ')');
            var lab = dd.querySelectorAll('span[role=combobox] > span');
            if (lab.length) lab[lab.length - 1].textContent = s.value;
            var u = s.closest('[data-nap-unidad]'), vi = u && u.querySelector('[data-nap-img]');
            if (vi) vi.setAttribute('src', img);
          } else {
            s.setAttribute('data-value', s.value);
          }
          sync();
        });
      });
    });
    sync();
    /* ---- ajout au panier : on envoie NOS lignes nous-memes. Moon Bundle (encore branche sur ce produit
       tant que son bundle n'est pas depublie) reecrit le formulaire au clic et remplace nos 3 / 5 pieces
       par son offre (__moonbundle) : mesure le 24/10. On le court-circuite en phase de capture. ---- */
    function ajouter(e) {
      if (!form) return;
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      sync();
      var fd = new FormData(), idInput = form.querySelector('[data-nap-id]');
      if (!idInput.disabled) { fd.append('id', idInput.value); fd.append('quantity', '1'); }
      Array.prototype.forEach.call(form.querySelectorAll('[data-nap-items] input'), function (i) { fd.append(i.name, i.value); });
      var b = form.querySelector('button[name="add"]'); if (b) b.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw r; window.location.href = '/cart'; })
        .catch(function () { if (b) b.removeAttribute('aria-busy'); alert('No se ha podido añadir al carrito. Inténtalo de nuevo.'); });
    }
    /* sur window en capture : avant tout ecouteur pose sur document par une app */
    window.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#nap-form button[name="add"]')) ajouter(e); }, true);
    window.addEventListener('submit', function (e) { if (e.target === form) ajouter(e); }, true);
    /* ---- liens « COMPRAR AHORA » des sections du bas : remonter a l'offre ---- */
    Array.prototype.slice.call(racine.querySelectorAll('a[href="#nap-oferta"]')).forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); var t = racine.querySelector('.kaching-bundles__bars') || racine; t.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    });
  });
})();
